<template>
  <NSelect class="n-country" v-bind="attrs" :get-popup-container="node => node.parentNode" />
</template>

<script setup>
import {useBootstrap} from '@front/hooks';
import {computed, watch} from 'vue';

const props = defineProps({
  value: undefined,
  bank: String,
});

const emit = defineEmits(['update:value']);

const { ENUMS } = useBootstrap();

const attrs = computed(() => ({
  options: ENUMS.value.Country,
  label: 'country',
  // ...useAttrs(),
  value: props.value,
  'onUpdate:value': v => emit('update:value', v),
}));

watch(
  () => {},
  to => {
    if (props.value && !to.find(o => o.value === props.value)) {
      emit('update:value', null);
    }
  },
);
</script>

<script>
export default {
  name: 'NCountry',
};
</script>
